import React from 'react'
import { PaymentSettings } from '../features/admin/components/PaymentSettings'

export const PaymentSettingsPage = () => {
  return <PaymentSettings/>
}

export default PaymentSettingsPage
